import { MapPin } from "@phosphor-icons/react";
import { Reveal, Eyebrow } from "./Reveal";

const TRADES = ["HVAC", "Plumbing", "Electrical", "Appliance Repair", "Garage Doors"];

const TOWNS = [
  "Niagara Falls", "St. Catharines", "Welland", "Thorold", "Niagara-on-the-Lake",
  "Fort Erie", "Port Colborne", "Grimsby", "Beamsville", "Hamilton",
];

export const Trades = () => (
  <section className="border-t-2 border-line bg-surface" data-testid="trades-section">
    <div className="mx-auto max-w-6xl px-4 py-20 sm:px-6 sm:py-28">
      <Reveal>
        <Eyebrow>Who it's for</Eyebrow>
        <h2 className="mt-4 font-display text-3xl font-bold uppercase leading-none tracking-tight sm:text-4xl md:text-5xl">
          Built for the trades
        </h2>
        <p className="mt-4 max-w-2xl text-base leading-relaxed text-gray-300 sm:text-lg">
          Owner-operated shops, one to fifteen people. The kind of business where the phone rings
          while everyone's on a job.
        </p>
      </Reveal>
      <div className="mt-12" data-testid="trades-list">
        {TRADES.map((trade, i) => (
          <Reveal key={trade} delay={i * 0.05}>
            <div className="group flex items-baseline gap-4 border-b-2 border-line py-4 sm:gap-8 sm:py-5">
              <span className="font-mono text-sm font-semibold text-safety">
                {String(i + 1).padStart(2, "0")}
              </span>
              <span className="font-display text-3xl font-bold uppercase tracking-tight transition-colors duration-200 group-hover:text-safety sm:text-5xl">
                {trade}
              </span>
            </div>
          </Reveal>
        ))}
      </div>
      <Reveal className="mt-14">
        <div className="flex items-start gap-3">
          <MapPin weight="bold" className="mt-1 h-6 w-6 shrink-0 text-safety" aria-hidden="true" />
          <div>
            <h3 className="font-display text-xl font-bold uppercase tracking-tight sm:text-2xl">
              On the road across
            </h3>
            <p className="mt-3 max-w-3xl text-base leading-relaxed text-gray-300 sm:text-lg" data-testid="service-area-list">
              {TOWNS.map((town, i) => (
                <span key={town}>
                  <span className={town === "Hamilton" ? "text-safety" : ""}>{town}</span>
                  {i < TOWNS.length - 1 && <span className="mx-2 text-smoke">·</span>}
                </span>
              ))}
            </p>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
